export enum BackEndUrlsEnum {
  downloadSakVer = 'api/Procuration/downloadSakVer/',
  Verify = 'api/Procuration/Verify',
  downloadTasdekDoc = 'api/Procuration/downloadTasdekDoc/',
  downloadSakFaskh = 'api/Procuration/downloadSakFaskh',
  SendOldConfirmationOtp = 'api/attorney-registration/SendOldConfirmationOtp',
  GetCopiedWekala = 'api/copywekala/GetCopiedWekala',
  submitOldWekala = 'api/attorney-registration/submitOldWekala',
  submitOldWekalaForm = 'api/attorney-registration/submitOldWekalaForm',
  testclauses = 'api/attorney-registration/testclauses',
  getPreviewText = 'api/attorney-registration/GetPreviewText',

  getSecondPartySefaLookups = 'api/Lookup/GetSecondPartySefas',
  getFirstPartySefaLookups = 'api/Lookup/GetFirstPartySefas',
  //ExternalTasdek
  exTasdekCheckRequester = 'api/ExternalTasdek/CheckRequester',
  exTasdekCheckfirstPartyNationalId = 'api/ExternalTasdek/CheckAndAddFirstPartyNationalId',
  exTasdekCheckSecondPartyNationalId = 'api/ExternalTasdek/CheckAndAddSecondPartyNationalId',
  exTasdekCheckfirstPartyIqama = 'api/ExternalTasdek/CheckAndAddFirstPartyIqama',
  exTasdekCheckfirstPartyGCC = 'api/ExternalTasdek/CheckAndAddFirstPartyGCC',
  exTasdekCheckfirstPartyPassport = 'api/ExternalTasdek/CheckAndAddFirstPartyPassport',
  exTasdekCheckfirstPartyVisitor = 'api/ExternalTasdek/CheckAndAddFirstPartyVisitor',
  exTasdekCheckfirstPartyForeign = 'api/ExternalTasdek/CheckAndAddFirstPartyForeign',
  exTasdekCheckfirstPartyCompany = 'api/ExternalTasdek/CheckAndAddFirstPartyCompany',
  exTasdekCheckSecondPartyIqama = 'api/ExternalTasdek/CheckAndAddSecondPartyIqama',
  exTasdekCheckSecondPartyGCC = 'api/ExternalTasdek/CheckAndAddSecondPartyGCC',
  exTasdekCheckSecondPartyPassport = 'api/ExternalTasdek/CheckAndAddSecondPartyPassport',
  exTasdekCheckSecondPartyVisitor = 'api/ExternalTasdek/CheckAndAddSecondPartyVisitor',
  exTasdekCheckSecondPartyForeign = 'api/ExternalTasdek/CheckAndAddSecondPartyForeign',
  exTasdekGetAllowedIdentities = 'api/ExternalTasdek/GetAllowedIdentities',
  exTasdekGetNationalities = 'api/ExternalTasdek/GetTasdekNationalities',
  exTasdekGetSource = 'api/ExternalTasdek/GetTasdekSource',
  exTasdekSendOtp = 'api/ExternalTasdek/SendOtp',
  exTasdekSubmitRequest = 'api/ExternalTasdek/SubmitRequest',
  exTasdekEditRequest = 'api/ExternalTasdek/EditRequest',
  exTasdekDeleteRequest = 'api/ExternalTasdek/DeleteRequest',
  exTasdekGetRequestForEdit = 'api/ExternalTasdek/GetRequestEdit',
  exTasdekGetRequestDetails = 'api/ExternalTasdek/GetRequestDetails',
  exTasdekGetUserRequests = 'api/ExternalTasdek/GetUserRequests',
  exTasdekValidateTasdekInfo = 'api/ExternalTasdek/ValidateTasdekInfo',
  exTasdekGetTasdekCountries = 'api/ExternalTasdek/GetTasdekCountries',
}

export enum BuilderBackEndUrl {
  initiateWithMowakel = `api/Mowakel/initiateWithMowakel`,
  initiate = `api/Mowakel/initiate`,
  updateMowakel = `api/Mowakel/update`,
  addMowakel = `api/Mowakel/Add`,
  mowakelGetAllwedSefa = `api/Mowakel/GetAllowedSefaList`,
  initiateCopy = `api/Mowakel/initiateCopy`,
  getDrafts = 'api/Draft/GetDrafts',
  initiateWithReissue = `api/Mowakel/reIssue`,
}

export enum FavoritePersonBackEndUrl {
  searchFavoritePersons = 'api/FavoritePerson/Search',
  getAllowedSefaForIdentityTypes = 'api/FavoritePerson/GetAllowedSefaForIdentityTypes',
  addFavoritePerson = 'api/FavoritePerson/add',
  getFavoriteList = 'api/FavoritePerson/GetFavoriteList',
  deleteFavoritePerson = 'api/FavoritePerson/Delete',
  updateFavoritePerson = 'api/FavoritePerson/Update',
  getFavoriteIdentitytypes = 'api/FavoritePerson/GetIdentityTypes',
  getFavoritePersonInfo = 'api/FavoritePerson/GetPersonInfo',
  getPassportInfoInfo = 'api/FavoritePerson/GetPassportInfo'
}
